export default __webpack_public_path__ + "static/mobile-planning-7e7314fa37e7a57cdd46473edb2686e3.png";